// import { useAppStore } from "../../appStore";

// export function GameTimeCalculation() {
//   const { selectedGame, profileData } = useAppStore();
//   let num = 4;

//   const gameTiming = () => {
//     const today = new Date();
//     const currentDay = today.getDay();
//     // An array to map the numeric representation to the actual day names
//     const daysOfWeek = [
//       "Sunday",
//       "Monday",
//       "Tuesday",
//       "Wednesday",
//       "Thursday",
//       "Friday",
//       "Saturday",
//     ];
//     // Get the name of the current day
//     const dayName = daysOfWeek[currentDay];
//     if (Object.keys(selectedGame).length === 0) {
//     } else {
//       const responseDayData = selectedGame.weekTimings.find(
//         (dayData) => dayData?.day === dayName
//       );
//       console.log("responseDayData", responseDayData);
//       console.log("selectedGame", selectedGame);
//       if (responseDayData) {
//         const openTime = responseDayData.time || "00:00";
//         const customerOpenTime =
//           selectedGame?.preClosingTimeOpen[num]?.openingTime || 0;
//         const [hours, minutes] = openTime.split(":").map(Number);
//         // Subtract customer open time in minutes
//         let resultMinutes = minutes - customerOpenTime;
//         console.log(
//           "    let resultMinutes = minutes - customerOpenTime;",
//           minutes,
//           customerOpenTime
//         );
//         let resultHours = hours;
//         // Adjust hours if needed
//         if (resultMinutes < 0) {
//           resultHours -= 1;
//           resultMinutes += 60;
//         }
//         const resultTime = `${String(resultHours).padStart(2, "0")}:${String(
//           resultMinutes
//         ).padStart(2, "0")}`;
//         // close time
//         const closeTime = responseDayData.time || "00:00";
//         const customerCloseTime =
//           selectedGame?.preClosingTimeClose[num]?.closingTime || 0;
//         console.log("customerCloseTime", customerCloseTime);
//         const [hours1, minutes1] = closeTime.split(":").map(Number);
//         // Subtract customer open time in minutes
//         let resultMinutes1 = minutes1 - customerCloseTime;
//         let resultHours1 = hours1;
//         // Adjust hours if needed
//         if (resultMinutes1 < 0) {
//           resultHours1 -= 1;
//           resultMinutes1 += 60;
//         }
//         const resultTime1 = `${String(resultHours1).padStart(2, "0")}:${String(
//           resultMinutes1
//         ).padStart(2, "0")}`;
//         // close time
//         //   setOpenTimeGame9(resultTime);
//         let time = {
//           openTime: resultTime,
//           closeTime: resultTime1,
//         };
//         return time;
//       } else {
//         console.log("Holiday.");
//         return "00:00";
//       }
//     }
//   };
//   return {
//     gameTiming,
//   };
// }

import axios from "axios";
import { useAppStore } from "../../appStore";
import { api_url } from "../../apiUtils";

export function GameTimeCalculation() {
  let token = sessionStorage.getItem("accesstoken");
  const { selectedGame, profileData } = useAppStore();
  let num = 4;

  const fetchMySinglePreClosing = async (id) => {
    try {
      const response = await axios.get(
        `${api_url}game/get-my-single-preclosing-time/${id}`,
        {
          headers: {
            accesstoken: token,
          },
        }
      );
      if (response.data.status === "success") {
        console.log(response.data.getPreClosingTime);
        return response.data.getPreClosingTime;
      } else {
        return null;
      }
    } catch (error) {
      console.error("Error fetching pre-closing time:", error);
      return null;
    }
  };

  const gameTiming = async () => {
    const today = new Date();
    const currentDay = today.getDay();

    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    const dayName = daysOfWeek[currentDay];

    if (Object.keys(selectedGame).length === 0) return;

    const responseDayData = selectedGame.weekTimings.find(
      (dayData) => dayData?.day === dayName
    );

    if (responseDayData) {
      const closeTime = responseDayData.time || "00:00";
      const customerCloseTime =
        selectedGame?.preClosingTime[num]?.closingTime || 0;

      let [resultHours1, resultMinutes1] = closeTime.split(":").map(Number);

      resultMinutes1 -= customerCloseTime;

      if (resultMinutes1 < 0) {
        resultHours1 -= 1;
        resultMinutes1 += 60;
      }

      const getSpecialCasePreClosing = await fetchMySinglePreClosing(
        selectedGame?._id
      );

      if (getSpecialCasePreClosing) {
        const adjustment = parseInt(getSpecialCasePreClosing.minutes, 10);

        if (getSpecialCasePreClosing.type === "minus") {
          resultMinutes1 -= adjustment;
        } else {
          resultMinutes1 += adjustment;
        }

        if (resultMinutes1 < 0) {
          resultHours1 -= Math.ceil(Math.abs(resultMinutes1) / 60);
          resultMinutes1 = ((resultMinutes1 % 60) + 60) % 60;
        } else if (resultMinutes1 >= 60) {
          resultHours1 += Math.floor(resultMinutes1 / 60);
          resultMinutes1 = resultMinutes1 % 60;
        }
      }

      let finalDate = new Date(today); // default today date

      if (resultHours1 >= 24) {
        finalDate.setDate(finalDate.getDate() + 1); // add one day
      }

      resultHours1 = resultHours1 % 24;

      const finalTime = `${String(resultHours1).padStart(2, "0")}:${String(
        resultMinutes1
      ).padStart(2, "0")}`;

      console.log("Final Date:", finalDate.toLocaleDateString("en-GB")); // dd/mm/yyyy
      console.log("Final Time:", finalTime);

      return {
        date: finalDate.toLocaleDateString("en-GB"),
        time: finalTime,
      };
    }
  };

  return {
    gameTiming,
  };
}
